import styled from 'styled-components';

export const UpdateModal = styled.div`
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.5);
    z-index: 4000 !important;
    display: flex;
    justify-content: center;
    align-items: center;
    @media all and (max-width: 500px) {
      display: block; 
    }
`;

export const UpdateModalBody = styled.div`
    width: 400px;
    background-color: #ffffff;
    padding: 30px;
    & h2 {
      margin-top: 0px;
    }
    @media all and (max-width: 500px) {
      height: 100%; 
    }
`;

export const UpdateModalFooter = styled.div`
    text-align: right;
`;

export const UpdateModalInput = styled.input`
    padding: 10px;
    background-color: #ffffff;
    border: 1px solid #000000;
    border-radius: 5px;
    width: 100%;
    margin-bottom: 20px;
`;

export const UpdateModalBtnWhite = styled.button`
  padding: 10px 20px;
  background-color: rgba(255,255,255,0.5);
  border-radius: 5px;
  color: #000000;
  border: 1px solid #dedede;
  cursor: pointer;
  transition-duration: 200ms;
  &:hover {
    transition-duration: 200ms;
    background-color: rgba(23, 125, 214, 0.2);    
  }
`;

export const UpdateModalBtn = styled.button`
  padding: 10px 20px;
  background-color: rgb(23, 125, 214);
  border-radius: 5px;
  color: #ffffff;
  border: 1px solid #dedede;
  cursor: pointer;
  margin-left: 10px;
  transition-duration: 200ms;
  &:hover {
    transition-duration: 200ms;
    opacity: 0.8;
  }
`;